import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';

/**
 * The `<CenteredContainer>` component is a max-width content container that's centered on the page.
 * It is another component that Nerds use as part of the Currency layout toolkit to more easily
 * translate Figma assets that have been created to the Currency Grid, into code.
 */
export var CenteredContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('CenteredContainer', {
    className: className
  });
  return /*#__PURE__*/React.createElement(Box, _extends({}, otherProps, {
    marginX: "auto",
    paddingX: {
      mobile: 3,
      desktop: 5
    },
    className: [classes('max-width-container'), className],
    ref: ref
  }), children);
});
CenteredContainer.displayName = 'CenteredContainer';